import { sessionSet, sessionGet } from "../storage";
export default {
    namespaced: true,
    state: {
        organizationFullPath: '',
        organizationInfo: '',
        activeKey: 0,
        courseInfo: null,
        reportInfo: null,
        reportCourse:null,
        courseHourResource: null,
        analysisOrganizationId: null
    },
    getters: {
        getOrganizationFullPath: state => () => {
            if (!state.organizationFullPath){
                state.organizationFullPath = sessionGet("organization/organizationFullPath");
            }
            return state.organizationFullPath
        },
        getOrganizationInfo: state => () => {
            if (!state.organizationInfo){
                state.organizationInfo = sessionGet("organization/setOrganizationInfo");
            }
            return state.organizationInfo
        },
        getActiveKey: state => state.activeKey || Number(sessionStorage.getItem("organization/setActiveKey")),
        getCourseInfo: state => () =>  {
            if (!state.courseInfo){
                state.courseInfo = sessionGet("COURSE_INFO");
            }
            return state.courseInfo
        },
        getReportInfo: state => state.reportInfo,
        getReportCourse: state => state.reportCourse,
        getCourseHourResource: state => {
            if (!state.courseHourResource){
                state.courseHourResource = JSON.parse(sessionStorage.getItem("COURSE_HOUR_RESOURCE"));
            }
            return state.courseHourResource
        },
        getAnalysisOrganizationId: state => () =>  {
            if (!state.analysisOrganizationId){
                state.analysisOrganizationId = sessionGet("ANALYSIS_ORGANIZATION_ID");
            }
            return state.analysisOrganizationId
        },
    },
    mutations: {
        setOrganizationFullPath(state, data) {
            state.organizationFullPath = data;
            sessionSet("organization/organizationFullPath", data)
        },
        setOrganizationInfo(state, organizationInfo) {
            state.organizationInfo = organizationInfo;
            sessionSet("organization/setOrganizationInfo", organizationInfo)
        },
        setActiveKey(state, index) {
            state.activeKey = index;
            sessionStorage.setItem("organization/setActiveKey", index)
        },
        setCourseInfo(state, courseInfo) {
            state.courseInfo = courseInfo;
            sessionSet("COURSE_INFO", courseInfo);
        },
        setReportInfo(state, reportInfo) {
            state.reportInfo = reportInfo;
        },
        setReportCourse(state, reportCourse) {
            state.reportCourse = reportCourse;
        },
        setCourseHourResource(state, courseHourResource) {
            state.courseHourResource = courseHourResource;
            sessionStorage.setItem("COURSE_HOUR_RESOURCE",JSON.stringify(courseHourResource));
        },
        setAnalysisOrganizationId(state, data){
            state.analysisOrganizationId = data;
            sessionSet("ANALYSIS_ORGANIZATION_ID", data);
        }
    },
    actions: {}
}
